import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import VersionHistoryOAuthClientAttribution from 'notebook/version-history/VersionHistoryOAuthClientAttribution';
import Avatar, {HasAvatar} from 'ui-library/avatar/Avatar';
import {AvatarSize, AvatarShape} from 'ui-library/avatar/AvatarConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

export default function VersionHistoryItemAvatar({
  user,
  tooltipText,
  oauth2ClientId,
  oauth2ClientName,
}: {
  user: HasAvatar;
  tooltipText?: string | JSX.Element;
  oauth2ClientId?: string;
  oauth2ClientName?: string;
}): JSX.Element {
  return (
    <div className={css(styles.flexRow)}>
      <Avatar size={AvatarSize.XXSMALL} shape={AvatarShape.CIRCLE} entity={user} showTooltip={false} />
      <span className={css(styles.userText)}>
        <Tooltip placement={FloatingPlacement.TOP} text={tooltipText}>
          <span>{user.name}</span>
        </Tooltip>
        <VersionHistoryOAuthClientAttribution
          oauth2ClientId={oauth2ClientId}
          oauth2ClientName={oauth2ClientName}
        />
      </span>
    </div>
  );
}

const styles = StyleSheet.create({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '5px',
  },
  userText: {
    fontSize: '12px',
    lineHeight: '16px',
  },
});
